<template>
  <div class="contain" ref="contain">
    <div class="wow animate__zoomInRight"
      style="font-size: max(7vw,48px);text-transform: uppercase;color: hsla(0,0%,100%,.3);font-weight: 600;letter-spacing:1px">
      Services</div>
    <div class="wow animate__zoomInRight" data-wow-delay="0.3s"
      style="font-size: max(5vw,24px);text-transform: uppercase;color: #fff;font-weight: 600;letter-spacing:1px">
      Services</div>
  </div>
  <div class="container">
    <!-- 左边的标题 -->
    <div class="title-column">
      <ul>
        <li v-for="(title, index) in titles" :key="index" :class="{ active: currentIndex === index }"
          @click="handleTitleClick($event, index)">
          {{ title }}
        </li>
      </ul>
    </div>
    <div class="middle-column">
      <!-- 中间的轮播图 -->
      <div class="carousel">
        <div class="carousel-inner" :style="carouselStyle" @mousedown="startDrag" @mouseup="endDrag"
          @mouseleave="endDrag">
          <img v-for="(image, index) in images" :key="index" :src="image" class="carousel-item" />
        </div>
      </div>

      <!-- 导航点 -->
      <div class="carousel-nav">
        <span v-for="(image, index) in images" :key="index" :class="{ active: currentIndex === index }" class="nav-dot"
          @click="handleNavDotClick(index)"></span>
      </div>
      <div style="font-weight: 500;line-height: 1.5;font-size: max(1.5vw,12px);">
        <p>{{ infos[currentIndex] }}</p>
      </div>
    </div>



    <!-- 右边的简介 -->
    <div class="description">
      <ul>
        <li v-for="(item, index) in descriptions[currentIndex]" :key="index">{{ item }}</li>
      </ul>
    </div>
  </div>

  <div class="container2" ref="container2">
    <h1>Engage with our Way of Work & <br />Explore our Services in Detail</h1>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';

const titles = ['DESIGN', 'Social Media', 'Digital Marketing', 'Content', 'Project Management'];
const descriptions = [
  ['Website Design', 'App Wireframes', 'User Interface', 'User Experience', 'Social Media Design', 'Digital Media Design', 'Ad Campaign Design', 'Marketing Collateral Design',],
  ['Strategy planning', 'Social media execution', 'Brand Social Equity', 'Campaign and community management', 'Social Channel Monitoring', 'Networking for Brands', 'Lead Generation', 'Social Media Communication'],
  ['Search Engine Optimization', 'Email Marketing Campaigns', 'PPC strategy', 'Backlink analysis', 'Multi-channel optimization', 'On-Page SEO Implementation', 'Customer behavior analysis', 'Conversion rate optimization'],
  ['Content marketing strategy', 'Content creation and curation', 'Content optimization', 'Keywords analytics', 'Website content', 'Brand story', 'User Generated Content', 'Social media feed and blogs',],
  ['Digital Tech Project Management', 'App Development', 'Technology Integration', 'Loyalty and Gamification', 'Market Research', 'Business Intelligence', 'Product Roadmapping', 'Concept to Product'],
];
const infos = [
  "Through innovative, clean design and firm design principles, we turn a digital experience into a human experience. We leverage your brand's vision and create a theme that not only boosts your brand's aesthetics but also spurs viewer engagement!",
  "Strategy is only as good as the power to execute it, and hence, we believe in nurturing a strong execution capability within our team. Sound strategy, a deep understanding of social platform algorithms, and consistent execution help us build communities, user engagement, and interaction for our clients like no one else!",
  "It's not rocket science to get users to your product through Ads, but the proof lies in conversions! ROI focused SEO and digital Advertising are the key pillars of our Digital Marketing Team. With a Global focus, our key experience in Ad Buying spreads across the US, Canada, India, Africa and European markets.",
  "Creative thinking is not limited to our drawing board, but more so the underlying driving force for all our Content as well. A balanced combination of Content creation and curation helps us create an authentic tone and human touch for your Brand!",
  "To build your legacy, you need the right set of people converting your vision into a tangible product or service! We provide teams across the board with experience in App Development, UI/UX, Market Research, Business Intelligence, and Project Execution. Working almost like an in-house team, we have delivered high-quality critical projects in TV, Media, Sports, Entertainment and Apps.",
];

const images = [
  require('@/assets/serve1.png'),
  require('@/assets/serve2.png'),
  require('@/assets/serve3.png'),
  require('@/assets/serve4.png'),
  require('@/assets/serve5.png'),
];

const currentIndex = ref(0);
const startX = ref(0);
const endX = ref(0);
const isMouseDown = ref(false); // 用于标记是否鼠标按下

const carouselStyle = computed(() => ({
  transform: `translateX(-${currentIndex.value * 100}%)`,
  transition: 'transform 0.3s ease',
}));

const handleTitleClick = (event, index) => {
  const ripple = document.createElement('span');
  const rect = event.target.getBoundingClientRect();
  const size = Math.max(rect.width, rect.height);
  const x = event.clientX - rect.left - size / 2;
  const y = event.clientY - rect.top - size / 2;

  ripple.style.width = ripple.style.height = `${size}px`;
  ripple.style.left = `${x}px`;
  ripple.style.top = `${y}px`;
  ripple.classList.add('ripple');

  event.target.appendChild(ripple);

  ripple.addEventListener('animationend', () => {
    ripple.remove();
  });

  currentIndex.value = index;
};

const handleNavDotClick = (index) => {
  currentIndex.value = index;
};

const startDrag = (event) => {
  startX.value = event.clientX;  // 记录按下时的X位置
  isMouseDown.value = true;  // 鼠标按下时标记为 true
};

const endDrag = (event) => {
  if (!isMouseDown.value) return;  // 如果没有按下则不执行后续操作

  endX.value = event.clientX;  // 记录抬起时的X位置
  isMouseDown.value = false;  // 解除按下标志

  // 计算水平滑动的距离
  const distance = endX.value - startX.value;

  if (Math.abs(distance) > 30) {
    if (distance > 0) {
      // 向右滑动
      currentIndex.value = (currentIndex.value - 1 + images.length) % images.length;
    } else {
      // 向左滑动
      currentIndex.value = (currentIndex.value + 1) % images.length;
    }
  }
};


const contain = ref(null);
const container2 = ref(null);
let observer = null;

const handleIntersection = (entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('clip-path-effect');
    } else {
      entry.target.classList.remove('clip-path-effect');
    }
  });
};
onMounted(() => {
  observer = new IntersectionObserver(handleIntersection, {
    threshold: 0.1 // 当元素 10% 进入视口时触发
  });
  if (contain.value) {
    observer.observe(contain.value);
  }
  if (container2.value) {
    observer.observe(container2.value);
  }
});

onUnmounted(() => {
  if (observer && contain.value) {
    observer.unobserve(contain.value);
  }
  if (observer && container2.value) {
    observer.unobserve(container2.value);
  }
});
</script>

<style lang="less" scoped>
.contain {
  background-image: url('../assets/service-one-bg.png') !important;
  background-repeat: no-repeat;
  background-position: 0% 0%;
  background-color: #fff;
  min-height: 80vh;
  position: relative;
  overflow: hidden;
  -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  transition: clip-path 1s ease, -webkit-clip-path 1s ease; // 添加过渡效果

  &.clip-path-effect {
    -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 80%);
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 80%);
  }

  >div:nth-child(1) {
    position: absolute;
    top: 20%;
    right: 10%;
  }

  >div:nth-child(2) {
    position: absolute;
    top: 25%;
    right: 15%;
  }
}

.container {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  gap: 20px;
  overflow: visible;
  /* 确保父容器不限制溢出 */
}

.container2 {
  background-image: url('../assets/service-two-bg.jpg') !important;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-size: cover;
  background-color: #fff;
  color: #fff;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
  -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
  transition: clip-path 1s ease, -webkit-clip-path 1s ease; // 添加过渡效果
  display: flex;
  justify-content: center;
  align-items: center;

  &.clip-path-effect {
    -webkit-clip-path: polygon(0 0, 100% 25%, 100% 100%, 0 100%);
    clip-path: polygon(0 0, 100% 25%, 100% 100%, 0 100%);
  }

  >h1 {
    font-weight: 500;
    font-size: max(2vw, 18px);
    line-height: 1.5;
  }
}

.middle-column {
  width: 50%;
}

.title-column {
  width: 25%;
  text-align: right;
  font-size: max(1.5vw, 12px);
  font-weight: 300;
}

.title-column ul {
  list-style: none;
}

.title-column li {
  padding: 10px;
  cursor: pointer;
  margin-bottom: 5px;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
}

.title-column li:hover,
.title-column li.active {
  background-color: #f0f0f0;
  font-weight: 700;
  font-size: max(2vw, 14px);
}

.carousel {
  position: relative;
  overflow: hidden;
  cursor: pointer;
  width: 80%;
  margin: auto;
}

.carousel-inner {
  display: flex;
  width: 100%;
}

.carousel-item {
  min-width: 100%;
  border-radius: 5px;
}

.carousel-nav {
  display: flex;
  justify-content: center;
  margin: 2vw 0px;
}

.nav-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #ccc;
  margin: 0 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.nav-dot.active {
  background-color: #0a0f38;
}

.description {
  width: 20%;
  text-align: left;

  >ul {
    margin: 0px;
    padding: 0px;
    color: #828282;

    >li {
      margin: 2vw 0px;
    }
  }
}

.description p {
  font-size: 16px;
}

:deep(.ripple) {
  position: absolute;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.3);
  transform: scale(0);
  animation: ripple-animation 0.6s linear;
}

@keyframes ripple-animation {
  to {
    transform: scale(4);
    opacity: 0;
  }
}


@media all and (max-width:600px) {
  .contain {
    min-height: 0px;
    aspect-ratio: 5/6 !important;

    >div:nth-child(1) {
      position: absolute;
      top: 40%;
      right: 10%;
    }

    >div:nth-child(2) {
      position: absolute;
      top: 45%;
      right: 15%;
    }
  }

  .container {
    flex-direction: column;

    >div {
      width: 100%;
      text-align: center;
    }

    >div:nth-child(1) {
      ul {
        margin: 0px;
        padding: 0px;
        overflow-x: scroll;
        white-space: nowrap;
        width: 100%;
        /* 确保宽度占满父容器 */
      }

      ul>li {
        display: inline-block;
        white-space: nowrap;
      }
    }

  }

  .container2 {
    min-height: 0px;
    aspect-ratio: 5/7 !important;

    &.clip-path-effect {
      -webkit-clip-path: polygon(0 0, 100% 15%, 100% 100%, 0 100%);
      clip-path: polygon(0 0, 100% 15%, 100% 100%, 0 100%);
    }
  }
}
</style>
